import clsx from "clsx";
import {useIntl} from "react-intl";
import {useRef} from "react";
import moment from "moment/moment";

export interface IComponent {
  fieldsProps: any;
  i18n: string;
  error?: string;
  value?: string;
  allDay?: boolean;
  touched?: boolean;
  onChange?(value: string): void;
  hideLabel?: boolean;
  disabled?: boolean;
}

export default function (props: IComponent) {
  const intl = useIntl()

  // Format value for the native input only on initial/external set,
  // not on every keystroke
  let displayValue = props.value || ''
  if (displayValue) {
    const allDayFormat = 'YYYY-MM-DD'
    const dateTimeFormat = 'YYYY-MM-DDTHH:mm'

    if (props.allDay && /^\d{4}-\d{2}-\d{2}$/.test(displayValue)) {
      // already correct format
    } else if (!props.allDay && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(displayValue)) {
      // already correct format
    } else {
      const date = moment(displayValue)
      if (date.isValid()) {
        displayValue = props.allDay ? date.format(allDayFormat) : date.format(dateTimeFormat)
      }
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value
    if (props.fieldsProps?.onChange) {
      props.fieldsProps.onChange(e)
    }
    if (props.onChange) {
      props.onChange(raw)
    }
  }

  return <>
    {!props.hideLabel &&
      <label className="fs-6 fw-semibold mb-2">{intl.formatMessage({id: props.i18n})}</label>
    }

    <input
      placeholder={intl.formatMessage({id: props.i18n})}
      type={props.allDay ? 'date' : 'datetime-local'}
      autoComplete='off'
      {...props.fieldsProps}
      onChange={handleChange}
      value={displayValue}
      disabled={props.disabled}
      className={'form-control form-control-solid'}
    />

    {(props.touched && props.error) && (
      <div className='fv-plugins-message-container'>
        <div className='fv-help-block'>
          <span role='alert'>{props.error}</span>
        </div>
      </div>
    )}
  </>
}
